import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPhpstormComponent } from './simple-icons-phpstorm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPhpstormComponent ],
    exports:      [ SimpleIconsPhpstormComponent ],
    bootstrap:    []
})
export class SimpleIconsPhpstormModule {}
